import { render, staticRenderFns } from "./TaxQuestion.vue?vue&type=template&id=7692d8c0&scoped=true&"
import script from "./TaxQuestion.vue?vue&type=script&lang=js&"
export * from "./TaxQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TaxQuestion.vue?vue&type=style&index=0&id=7692d8c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7692d8c0",
  null
  
)

export default component.exports